const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE, ApiDataModel.SIMULATIONS)

export const apiProductionCorrections = {
	fetchRawMaterialsByVariant: async (
		simulationID: number,
		semiProductId: number,
	): Promise<IApiResponseModel<IRawMaterialsByVariantResponse>> => {
		const response = await apiCommon<IRawMaterialsByVariantResponse>(
			`${groupPrefix}/${simulationID}/semi-products/${semiProductId}/raw-materials-by-variant`,
			{
				method: 'GET',
			},
		)

		// This endpoint returns the payload at the top level (no `data` wrapper),
		// but stay tolerant if the backend later wraps it.
		const payload = response as unknown as Record<string, unknown>
		const data = (payload?.data ?? payload) as unknown as IRawMaterialsByVariantResponse

		return { data }
	},

	fetchProductionRows: async (
		simulationID: number,
		semiProductId: number,
	): Promise<IApiResponseModel<IProductionRowsResponse>> => {
		const response = await apiCommon<IProductionRowsResponse>(
			`${groupPrefix}/${simulationID}/semi-products/${semiProductId}/production-rows`,
			{
				method: 'GET',
			},
		)

		// This endpoint returns the payload at the top level (no `data` wrapper),
		// but stay tolerant if the backend later wraps it.
		const payload = response as unknown as Record<string, unknown>
		const data = (payload?.data ?? payload) as unknown as IProductionRowsResponse

		return { data }
	},

	storeProductionCorrection: async (
		simulationID: number,
		payload: IStoreProductionCorrectionRequest,
	): Promise<IStoreProductionCorrectionResponse> => {
		const response = await apiCommon<IStoreProductionCorrectionResponse>(
			`${groupPrefix}/${simulationID}/production-corrections`,
			{
				method: 'POST',
				body: payload,
			},
		)

		// Response is flat (no `data` wrapper); stay tolerant if the backend later wraps it.
		const raw = response as unknown as Record<string, unknown>
		return (raw?.data ?? raw) as unknown as IStoreProductionCorrectionResponse
	},

	previewGroupedTasks: async (
		simulationID: number,
		payload: IPreviewGroupedTasksRequest,
	): Promise<IApiResponseModel<IPreviewGroupedTasksResponse>> => {
		const response = await apiCommon<IPreviewGroupedTasksResponse>(
			`${groupPrefix}/${simulationID}/production-corrections/preview-grouped-tasks`,
			{
				method: 'POST',
				body: payload,
			},
		)

		const raw = response as unknown as Record<string, unknown>
		const data = (raw?.data ?? raw) as unknown as IPreviewGroupedTasksResponse

		return { data }
	},

	storeGroupedTaskCorrection: async (
		simulationID: number,
		payload: IStoreGroupedTaskCorrectionRequest,
	): Promise<IStoreGroupedTaskCorrectionResponse> => {
		const response = await apiCommon<IStoreGroupedTaskCorrectionResponse>(
			`${groupPrefix}/${simulationID}/production-corrections`,
			{
				method: 'POST',
				body: payload,
			},
		)

		const raw = response as unknown as Record<string, unknown>
		return (raw?.data ?? raw) as unknown as IStoreGroupedTaskCorrectionResponse
	},
}
